import React from 'react';
import PropTypes from 'prop-types';
import withHeadlineProps from './headlineProps';
import './headline.scss';

/**
 * H6 text component
 */

export function H6(props) {
	return (
		<h6 className={props.className}>
			{props.children}
		</h6>
	);
}

H6.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node
};

export default withHeadlineProps(H6);
